/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Numberofmentees2Inputs */

const en__field_numberofmentees2 = /** @type {(inputs: _Field_Numberofmentees2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Number of Students`)
};

const de__field_numberofmentees2 = /** @type {(inputs: _Field_Numberofmentees2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anzahl Schüler:innen`)
};

/**
* | output |
* | --- |
* | "Number of Students" |
*
* @param {_Field_Numberofmentees2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_numberofmentees2 = /** @type {((inputs?: _Field_Numberofmentees2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Numberofmentees2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_numberofmentees2(inputs)
	return de__field_numberofmentees2(inputs)
});
export { _field_numberofmentees2 as "_field_numberOfMentees" }